import { TP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { JobOfferKindListType } from 'types/kodawari';
import {
  JobCountResponse,
  SavedSearchResponse,
} from '@doda/api-client/aspida/@types';
import { FeaturedSearchConditionQuery } from 'components/SearchSideBar/types';
import { JOB_OFFER_KIND_CODE_AND_QUERY } from 'constants/searchCondition';
import { getInitialIdList } from '../getInitialIdList';

interface ArgumentType {
  savedSearchCondition?: SavedSearchResponse | undefined;
  featuredSearchCondition?: FeaturedSearchConditionQuery | undefined;
  query: string | undefined;
  jobCountData: JobCountResponse;
}

/**
 * 応募方法の初期状態を生成
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.query クエリパラメータ
 * @param param.jobCountData 求人件数
 * @returns 応募方法の初期状態
 */
export const createInitialJobOfferKindList = ({
  savedSearchCondition,
  featuredSearchCondition,
  query,
  jobCountData,
}: ArgumentType) => {
  const id = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    query,
  });

  const initialData: JobOfferKindListType[] = [
    {
      id: JOB_OFFER_KIND_CODE_AND_QUERY.DIRECT_APPLICATION.code,
      name: TP_SEARCH_ITEMS.directApplication.name,
      isChecked: id === JOB_OFFER_KIND_CODE_AND_QUERY.DIRECT_APPLICATION.code,
      value: JOB_OFFER_KIND_CODE_AND_QUERY.DIRECT_APPLICATION.code,
      jobCount: findJobCount(
        jobCountData.jobOfferKindList,
        JOB_OFFER_KIND_CODE_AND_QUERY.DIRECT_APPLICATION.code
      ),
    },
    {
      id: JOB_OFFER_KIND_CODE_AND_QUERY.AGENT_SERVICES.code,
      name: TP_SEARCH_ITEMS.agentServices.name,
      isChecked: id === JOB_OFFER_KIND_CODE_AND_QUERY.AGENT_SERVICES.code,
      value: JOB_OFFER_KIND_CODE_AND_QUERY.AGENT_SERVICES.code,
      jobCount: findJobCount(
        jobCountData.jobOfferKindList,
        JOB_OFFER_KIND_CODE_AND_QUERY.AGENT_SERVICES.code
      ),
    },
  ];

  return initialData;
};
